<template>
    <div class="card">
        <div class="card-body">
            <h4 class="title text-primary mb-0">{{ __('Top active Institutions') }}</h4>
            <div class="mt-4">
                <Spinner v-if="loading" spinner-type="grow" min-height="320px" />
                <template v-else-if="institutions.length">
                    <div v-for="(institution, i) in institutions" class="d-flex align-items-start gap-2 mb-3" :key="i">
                        <div class="border rounded py-1 px-2">
                            {{ en_to_bn(institution.eiin_number) }}
                        </div>
                        <div>
                            <div>
                                {{ locale_attr(institution, 'institution_{lang}_name') ||
                                    institution.institution_en_name }}
                            </div>
                            <small>
                                {{ [locale_attr(institution, 'upazila_name_{lang}g') || institution.upazila_name_eng,
                                locale_attr(institution, 'district_name_{lang}g') || institution.district_name_eng,
                                locale_attr(institution, 'division_name_{lang}g') || institution.division_name_eng
                                ].join(', ') }}
                            </small>
                        </div>
                    </div>
                </template>
                <div v-else class="d-flex justify-content-center align-items-center" style="min-height: 320px">
                    {{ __('No data found') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Spinner from '../../components/Spinner';

export default {
    components: {
        Spinner,
    },

    data() {
        return {
            institutions: [],
            loading: false,
        }
    },

    mounted() {
        this.observe_visibility(this.$el, () => this.fetchInstitutions());
    },

    methods: {
        fetchInstitutions() {
            this.loading = true;
            axios.get('/dashboard/top-active-institutions')
                .then(({ data }) => this.institutions = data.institutions)
                .catch(console.error)
                .finally(() => this.loading = false);
        },
    },
}
</script>